import React from "react";
import { Link } from "react-router-dom";

export const TextLink =  React.forwardRef((props, ref) => {
    const { to } = props;

    return <Link ref={ref} style={{ textDecoration: 'none', color: "white" }} to={to} {...props} />;
});

export default TextLink;